import Link from "next/link"
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink"

export const V3ProfileListItemLink: React.FunctionComponent<React.PropsWithChildren<{ href: string, target: string | undefined, onClick?: (e?: React.MouseEvent) => void, onAuxClick?: (e?: React.MouseEvent) => void, decorative?: boolean }>> = ({ href, target, onClick, onAuxClick, decorative, children }) => {
    const hiddenProps = decorative ? { "aria-hidden": true, tabIndex: -1 } : {};

    if (target === "_blank") {
        return <UnstyledLink href={href} target={target} rel="nofollow" onClick={onClick} onAuxClick={onAuxClick} {...hiddenProps}>{children}</UnstyledLink>
    }

    return <Link href={href} passHref legacyBehavior>
        <UnstyledLink target={target} onClick={onClick} onAuxClick={onAuxClick} {...hiddenProps}>
            {children}
        </UnstyledLink>
    </Link>
}
